import { Resources } from 'constants/resources';

import { RolesForm } from 'pages/Roles/components/RolesForm/RolesForm';
import { RaRecord, useNotify, useRedirect } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';
import { Role } from 'types/embedded/role';

const transform = ({ roleCategories, ...data }: RaRecord): RaRecord => ({
  ...data,
  roleCategories: Array.isArray(roleCategories) ? roleCategories[0] : roleCategories,
});

export const RolesCreate: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (role: Role) => {
    notify(
      <>
        Роль <TypographyBold text={role.name} /> создана
      </>,
      { type: 'success' },
    );
    redirect('list', Resources.Roles);
  };

  return (
    <CreateGuesserPage
      listName="Роли"
      mutationOptions={{ onSuccess, onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButtonValidated key="save-button" />,
      ]}
      title="Cоздание роли"
      transform={transform}
    >
      <RolesForm />
    </CreateGuesserPage>
  );
};
